import ListeTypeTaxePage from "@/pages/GesCom/TypeTaxe/ListeTypeTaxePage.vue";

interface MenuItem {
    headTitle1?: string;
    headTitle2?: string;
    title?: string;
    icon?: string;
    icon1?: string;
    type: string;
    badgeType?: string;
    badgeValue?: string;
    active?: boolean;
    isPinned?: boolean;
    path?: string;
    children?: MenuItem[];
    bookmark?: boolean;
    role?: string;
}

export const menu: MenuItem[] = [
    {
        path: "/accueil/tableau-bord",
        title: "Tableau de bord",
        type: "link",
        icon: "stroke-home",
        icon1: "fill-home",
        active: false,
        isPinned: false,
        role: "DashBord"
    },


    {
        headTitle1: "Gestion des inventaires",
        headTitle2: "Gestion des inventaires",
        type: "headtitle",
        role: "ListProduit|ListFamille|ListConditionnement|ListMagasin|AddMouvement|EtatInventaire|ListMouvement"
    },
    {
        title: "Gestion des produits",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit",
        children: [
            {
                path: "/produits/liste-produits",
                title: "produits",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListProduit"
            },
            {
                path: "/familles/liste-familles",
                title: "catégories",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListFamille"
            },
            {
                path: "/conditionnements/liste-conditionnements",
                title: "conditionnements",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListConditionnement"
            },

        ]
    },

    {
        title: "Gestion des inventaires",
        icon: "stroke-learning",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit|ListFamille|ListConditionnement|ListMagasin|ListPointVente",

        children: [
            {
                path: "/inventaires/liste-inventaires",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des inventaires",
                isPinned: false,
                type: "link",
                role: "ListProduit"
            },

            {
                path: "/inventaires/liste-fiche-inventaires",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des fiches d'inventaires",
                isPinned: false,
                type: "link",
                role: "ListeFicheProduit"
            },

            {
                path: "/inventaires/ajouter-inventaire",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Créer une fiche d'inventaire",
                isPinned: false,
                type: "link",
                role: "ListProduit"
            },
            {
                path: "/inventaires/inventorier",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Inventorier",
                isPinned: false,
                type: "link",
                role: "EditInventaire"
            },
            {
                path: "/inventaires/ajouter-mouvement",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Mouvement",
                isPinned: false,
                type: "link",
                role: "AddMouvement"
            },
            {
                path: "/inventaires/liste-produit-inventaire",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Etats inventaire",
                isPinned: false,
                type: "link",
                role: "ListMouvement"
            },
            {
                path: "/inventaires/liste-mouvements",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des mouvements",
                isPinned: false,
                type: "link",
                role: "ListMouvement"
            },


        ]
    },

    {
        title: "Gestion des Clients",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeClient|ListCompte|AddCompte|AddClient",
        children: [
            {
                path: "/clients/liste-clients",
                title: "Clients",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeClient"
            },

        ]
    },
    {
        title: "Gestion des bons",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "AddBonCommandeFournisseur|AddDemandePrix|ListeBonCommandeFournisseur|",
        children: [
            {
                path: "/bons-commandefournisseurs/ajouter-boncommandefournisseur",
                title: "Commandes fournisseurs",
                type: "link",
                role: "AddBonCommandeFournisseur"
            },
            {
                path: "/bons-commandefournisseurs/liste-commandefournisseurs",
                title: "Liste des commandes fournisseurs",
                type: "link",
                role: "ListeBonCommandeFournisseur"
            },
            {
                path: "/demandes-prix/liste-demande-prix",
                title: " Demandes de prix",
                type: "link",
                role: "AddDemandePrix"
            },

        ]
    },

     {
        title: "Gestion des règlements",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListCreance|AddCreance|ListEcheance|ListReglement|ListRapportRelance|ListDepot|AddDepot|AddRapportRelance|AddReglement",
        //role: "ListMagasin",
        children: [
            // {
            //     path: "/creances/ajouter-creance",
            //     title: "Ajouter une créance",
            //     type: "link",
            //     role: "AddCreance"
            //     // role: "ListMagasin"
            // },
            // {
            //     path: "/creances/liste-creances",
            //     title: "Liste des créances",
            //     type: "link",
            //    role: "ListCreance" 
            // },
            //  {
            //     path: "/echeances/liste-echeances",
            //     title: "Liste des échéances",
            //     type: "link",
            //     role: "ListEcheance"
            // },
            // {
            //     path: "/depots/liste-depots",
            //     title: "Dépôts d'argent",
            //     role: "ListDepot",
            //     type: "link"

            // },
            // {
            //     path: "/rapportRelances/liste-rapportRelance",
            //     title: "Rapports de relance",
            //     type: "link",
            //     icon: "stroke-learning",
            //     icon1: "fill-learning",
            //     isPinned: false,
            //     role: "ListRapportRelance"
            // },
            {
                path: "/reglements/liste-reglements",
                title: "Règlements",
                type: "link",
                role: "ListReglement"
            },
            
        ]
    },

    {
        title: "Fournisseurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListFournisseur|AddFournisseur",
        children: [
            {
                path: "/fournisseurs/ajouter-fournisseur",
                title: "Ajouter un fournisseur",
                role: "AddFournisseur",
                type: "link"
            },
            {
                path: "/fournisseurs/liste-fournisseurs",
                title: "Liste des fournisseurs",
                role: "ListFournisseur",
                type: "link"
            },
        ]
    },


    {
        title: "Vente",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/ventes/ajouter-vente",
                title: "Ajouter une vente",
                type: "link"
            },
            {
                path: "/ventes/liste-ventes",
                title: "Liste des ventes",
                type: "link"
            },
        ]
    },

    {
        title: "Etats",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/etats/produits-disponibles",
                title: "stock actuelle",
                type: "link"
            },
            {
                path: "/etats/produits-vendus",
                title: "Liste des produits vendus",
                type: "link"
            },
            {
                path: "/etats/produits-livres",
                title: "Liste des produits livres",
                type: "link"
            },
            {
                path: "/etats/produits-rupture",
                title: "Liste des produits en rupture de stock",
                type: "link"
            },
            {
                path: "/etats/point-commande",
                title: "Liste du point des commandes",
                type: "link"
            },
            {
                path: "/etats/etat-produits-entree",
                title: "Liste des produits entrées",
                type: "link"
            },
            {
                path: "/etats/etats-produits-sorties",
                title: "Liste des produits sorties",
                type: "link"
            },
            {
                path: "/etats/etat-nmbre-pro",
                title: 'Nombre du produits vendus par période',
                type: "link"
            },
            // {
            //     path: "/etats/ca-client",
            //     title: `Chiffre d'affaire par client`,
            //     type: "link"
            // }
        ]
    },

    {
        title: "Stock",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/detachements/liste-detachements",
                title: "Liste des detachements",
                type: "link"
            },
            {
                path: "/sorties/liste-sorties",
                title: "Liste des sorties",
                type: "link"
            },
            {
                path: "/transferts/liste-transferts",
                title: "Liste des transferts par point de vente",
                type: "link"
            },
            {
                path: "/transferts/liste-transfertMag",
                title: "Liste des transferts par magasin ",
                type: "link"
            },
            {
                path: "/approvisionnements/liste-approvisionnements",
                title: "Liste des approvisionnements",
                type: "link"
            },
            {
                path: "/livraisons/liste-livraisons",
                title: "Liste des livraisons",
                type: "link"
            },
        ]
    },

    {
        title: "Caisse",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/caisses/liste-caisses",
                title: "Liste des caisses",
                type: "link"
            },


            {
                path: "/OuverturesFermetures",
                title: "Liste des caisses ouvertes et fermées",
                type: "link"
            },

        ]
    },

    {
        title: "Monnaies",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/monnaies/liste-monnaies",
                title: "Liste des monnaies",
                type: "link"
            },

        ]
    },

    {
        title: "Société",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/societes/liste-societes",
                title: "sociétés",
                type: "link"
            },

        ]
    },
    {

        title: "Facture",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/factures/liste-factures",
                title: " factures",
                type: "link"
            },


        ]
    },

    {
        title: "Paramètres",
        icon: "stroke-learning",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit|ListFamille|ListConditionnement|ListMotifSuivi|ListMagasin|ListPointVente|AddClient|ListClient|ListTaxe|ListTypeTaxe|ListModeRegelement|",
        children: [


            {
                path: "/magasins/liste-magasins",
                title: "magasins",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                type: "link",
                role: "ListMagasin"
            },

            {
                path: "/point-ventes/liste-point-ventes",
                title: "points de vente",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListPointVente"
            },
            {
                path: "/liste-groupe-taxes",
                title: "groupe de taxe",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
            },
            {
                path: "/liste-taxes",
                title: "Taxe",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListTaxe"
            },


            {
                path: "/modele-signataires/liste-modele-signataires",
                title: "modèles de signataires",
                type: "link"
            },

            {
                path: "/liste-type-taxes",
                title: "Type de taxe",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListTypeTaxe"
            },

            {
                path: "/mode-reglements/liste-mode-reglements",
                title: "Modes de règlement",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListModeReglement"
            },

        ]
    },


    {
        headTitle1: "Gestion des utilisateurs",
        headTitle2: "Utilisateurs, Rôles et permissions",
        type: "headtitle",
        role: "AddUser|ListUser|AddRole|ListRole|ListPermission"
    },

    {
        title: "Gestion des utilisateurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListUser",
        children: [

            {
                title: "Utilisateurs",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListUser",
                children: [
                    {
                        path: "/utilisateurs/ajouter-utilisateur",
                        title: "Ajouter un utilisateur",
                        type: "link",
                        role: "AddUser"
                    },
                    {
                        path: "/utilisateurs/liste-utilisateur",
                        title: "Liste des utilisateurs",
                        type: "link",
                        role: "ListUser"
                    },
                ]
            },
            {
                title: "Role",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListRole",
                children: [
                    {
                        path: "/roles/ajouter-role",
                        title: "Ajouter un rôle",
                        type: "link",
                        role: "AddRole"
                    },
                    {
                        path: "/roles/liste-role",
                        title: "Liste des rôles",
                        type: "link",
                        role: "ListRole"
                    },
                ]
            },
            {
                title: "Permissions",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListPermission",
                children: [
                    {
                        path: "/permissions/liste-permission",
                        title: "Liste des permissions",
                        type: "link",
                        role: "ListPermission"
                    },

                ]
            },


        ]
    },
]


